import React, { useContext } from "react";
import Popup from "@ui/popup";
import WidgetPage from "./widget-page";
import AppDataContext from "@stores/app-data-context";
import { AppDataContextProvider } from "@stores/app-data-context";
import { PageActionContextProvider } from "@stores/page-action-context";
import { PopupContextProvider } from "@stores/popup-context";

const WidgetPageWrap = ({
    path,
    requestMethod,
    requestBodyKey,
    loadingScreenVm,
}) => {
    const cxt = useContext(AppDataContext);

    if (requestMethod !== "POST") return <WidgetPage path={path} />;

    return (
        <WidgetPage
            path={path}
            requestBody={cxt.getRequestBody(requestBodyKey)}
            requestMethod={requestMethod}
            loadingScreenVm={loadingScreenVm}
        />
    );
};

const DefaultPage = ({
    path,
    requestMethod,
    requestBodyKey,
    loadingScreenVm,
}) => {
    return (
        <PageActionContextProvider>
            <AppDataContextProvider>
                <PopupContextProvider>
                    <WidgetPageWrap
                        path={path}
                        requestMethod={requestMethod}
                        requestBodyKey={requestBodyKey}
                        loadingScreenVm={loadingScreenVm}
                    />
                    <Popup />
                </PopupContextProvider>
            </AppDataContextProvider>
        </PageActionContextProvider>
    );
};
export default DefaultPage;
